module.exports = __webpack_public_path__ + "img/turntable-bg.28fd569f.png";